import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { urlConfig } from '../../../config/url.config';
import { General } from '../enum/general.enum';
import {
  ConsultationCpfcreditScoreTHModel,
  ConsultationCpfModel,
} from '../models/consultation-cpf.model';

@Injectable()
export class StartHttpService {
  public url: any;
  public headers = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    }),
  };
  public MAX_RETRY = 4;
  public DELAY = 1000;

  constructor(public https: HttpClient) {
    this.url = urlConfig.url_hub_cpf;
  }

  handleError(error?) {
    return throwError(error);
  }

  public sendCPF(payload: ConsultationCpfModel): Observable<any> {
    return this.https
      .post(this.url, { ...payload, origin: '2' }, this.headers)
      .pipe(
        mergeMap((response) => {
          if (!response[General.idflow]) {
            payload.step++;
            return this.sendCPF(payload).pipe(
              map((response) => {
                //console.log('MAP', response);
                if (response[General.idflow]) {
                  return response;
                }
              }),
              catchError(this.handleError)
            );
          } else {
            if (response[General.idflow]) {
              return of(response);
            }
          }
        }),
        catchError(this.handleError)
      );
  }

  public sendCPFcreditScoreTH(
    payload: ConsultationCpfcreditScoreTHModel
  ): Observable<any> {
    return this.https.post(this.url, payload, this.headers).pipe(
      mergeMap((response) => {
        return of(response);
      }),
      catchError(this.handleError)
    );
  }
}
